import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=17212e1f&scoped=true&lang=pug&"
import script from "./SectionCard.vue?vue&type=script&lang=ts&"
export * from "./SectionCard.vue?vue&type=script&lang=ts&"
import style0 from "./SectionCard.vue?vue&type=style&index=0&id=17212e1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17212e1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
